import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const Loader = ({ loadingCounter }) => {
  // const [loadingCounter, setLoadingCounter] = useState(0);
  // const location = useLocation();

  // useEffect(() => {
  //   setLoadingCounter(0);

  //   const interval = setInterval(() => {
  //     setLoadingCounter((prev) => {
  //       if (prev < 100) {
  //         return prev + 1;
  //       } else {
  //         clearInterval(interval);
  //         return 100;
  //       }
  //     });
  //   }, 30); // Adjust the interval duration as needed

  //   return () => clearInterval(interval);
  // }, [location]);

  return (
    <div className="loader">
      <div className="loader__wrapper">
        <h2 className="heading">Almost there!</h2>
        <div className="loader__line">
          {/* <div className="line" style={{ width: `${loadingCounter}%` }}></div> */}
          {/* <div className="counter">{loadingCounter}%</div> */}
          <div
            className="progress-circle"
            style={{ "--progress": loadingCounter }}>
            <div className="progress-text">{`${loadingCounter}%`}</div>
          </div>
        </div>
        <h2 className="heading">Just a sec...</h2>
      </div>
    </div>
  );
};

export default Loader;
